import { FC, useState } from 'react';
import { DialogContentText, TextField } from '@mui/material';
import axios from 'axios';

import { aiSchedulerFeedbackApiInfoAtom, useAuthContext } from '../../../../data-access';
import { useRecoilValue } from 'recoil';
import { BasicDialog } from '../../../common/BasicDialog';
import './AISchedulerFeedbackDialog.scss';
import { useTranslation } from 'react-i18next';

interface AISchedulerFeedbackDialogProps {
  visible: boolean;
  onClose: () => void;
  onDiscard: () => void;
}

const formUrl =
  'https://docs.google.com/forms/d/e/1FAIpQLSdyHm6Dxg95R9WKTeZAwyOmvj-XPKW4L-gdmxMNjk-6EF2zXA/formResponse';
enum FormKeys {
  userId = 'entry.577930260',
  feedback = 'entry.1193364122',
  appApiRes = 'entry.830765065',
  preferences = 'entry.1105158981',
  currentTime = 'entry.570017597',
  scienceApiReq = 'entry.1082028300',
  scienceApiRes = 'entry.431039372',
}

const AISchedulerFeedbackDialog: FC<AISchedulerFeedbackDialogProps> = ({
  visible,
  onClose,
  onDiscard,
}) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const [feedback, setFeedback] = useState('');
  const aiSchedulerFeedbackApiInfo = useRecoilValue(aiSchedulerFeedbackApiInfoAtom);

  const handleClose = () => {
    setFeedback('');
    onClose();
  };

  const handleSend = async () => {
    const trimmedFeedback = feedback.trim();
    if (!trimmedFeedback) {
      setFeedback('');
      onDiscard();
      return;
    }

    const submitParams = new FormData();
    submitParams.append(FormKeys.userId, user.userId);
    submitParams.append(FormKeys.feedback, trimmedFeedback);
    if (aiSchedulerFeedbackApiInfo) {
      submitParams.append(FormKeys.appApiRes, aiSchedulerFeedbackApiInfo.appApiRes);
      submitParams.append(FormKeys.preferences, aiSchedulerFeedbackApiInfo.preference);
      submitParams.append(FormKeys.currentTime, aiSchedulerFeedbackApiInfo.currentTime);
      submitParams.append(FormKeys.scienceApiReq, aiSchedulerFeedbackApiInfo.scienceApiReq);
      submitParams.append(FormKeys.scienceApiRes, aiSchedulerFeedbackApiInfo.scienceApiRes);
    }

    try {
      await axios.post(formUrl, submitParams);
    } catch (error) {
      console.error('Error', 'Failed to submit feedback', error);
    } finally {
      setFeedback('');
      onDiscard();
    }
  };

  return (
    <BasicDialog
      visible={visible}
      title={t('task.scheduler.feedback.discardTitle')}
      ctaString={t('task.scheduler.feedback.yes')}
      hideCancel
      showCloseIcon
      onYes={handleSend}
      onClose={handleClose}
      width="sm"
    >
      <div className="ai-scheduler-feedback-dialog__content">
        <DialogContentText>{t('task.scheduler.feedback.description')}</DialogContentText>
        <TextField
          id="ai-scheduler-basic"
          label={t('task.scheduler.feedback.label')}
          placeholder={t('task.scheduler.feedback.placeholder')}
          variant="standard"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          fullWidth
          className="ai-scheduler-feedback-dialog__input"
        />
      </div>
    </BasicDialog>
  );
};

export default AISchedulerFeedbackDialog;
